export function GetImportId(ImportId, ImportFileName, ImpportUploadedDate) {
    this.id = ImportId
    this.name = ImportFileName
    this.uploadedDate = ImpportUploadedDate
}
